Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.YoutubeVideo

  constructor: (id, channelId, channelName, channelThumbnail, categoryId, title, description, duration, defaultLanguage, publishedAt, tags, thumbnailUrlMediumRes, thumbnailHeightMediumRes, thumbnailWidthMediumRes, thumbnailUrlStandardRes, thumbnailHeightStandardRes, thumbnailWidthStandardRes, privacyStatus, rawData) ->
    @id = id
    @channelId = channelId
    @channelName = channelName
    @channelThumbnail = channelThumbnail
    @categoryId = categoryId
    @title = title
    @description = description
    @duration = duration
    @defaultLanguage = defaultLanguage
    @publishedAt = publishedAt
    @tags = tags
    @thumbnailUrlMediumRes = thumbnailUrlMediumRes
    @thumbnailHeightMediumRes = thumbnailHeightMediumRes
    @thumbnailWidthMediumRes = thumbnailWidthMediumRes
    @thumbnailUrlStandardRes = thumbnailUrlStandardRes
    @thumbnailHeightStandardRes = thumbnailHeightStandardRes
    @thumbnailWidthStandardRes = thumbnailWidthStandardRes
    @privacyStatus = privacyStatus
    @rawData = rawData

  link: () ->
    "https://youtube.com/watch?v=#{@id}"

